import React from 'react'

import VideoHero from '../../video-hero'

function StoryblokProductSelectorAdapter(props) {
  return <VideoHero {...props} />
}

export default StoryblokProductSelectorAdapter
